import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  ObjetivoSection,
  AlcanceMVPSection,
  ValorSection,
  EscalabilidadSection,
  InversionSection,
  EntregaSection,
  AreYouReady,
} from './components';

const LandingMediaKitIndesagro = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
        position="relative"
      >
        <Hero themeMode={themeMode} />
      </Box>
      <Container>
        <ObjetivoSection />
      </Container>
      <Container>
        <AlcanceMVPSection />
      </Container>
      <Container>
        <ValorSection />
      </Container>
      <Box bgcolor={theme.palette.alternate.main}>
        <Container>
          <EscalabilidadSection />
        </Container>
      </Box>
      <Container>
        <InversionSection />
      </Container>
      <Container>
        <EntregaSection />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitIndesagro.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitIndesagro;
